import * as React from "react";
import { Button, ButtonProps } from "@/components/ui/button";

export interface ActionButtonProps extends ButtonProps {
  asChild?: boolean;
}

/**
 * ActionButton component that defaults to type="button" to prevent
 * form submission side effects when used inside forms.
 */
export const ActionButton = React.forwardRef<
  HTMLButtonElement,
  ActionButtonProps
>(({ type = "button", ...props }, ref) => {
  return <Button type={type} ref={ref} {...props} />;
});

ActionButton.displayName = "ActionButton";
